import React, {useEffect, useState, useRef, useContext} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import styles from './MobileMenu.module.css';
import logo_svg from "../../static_files/PrismaxLogoWhite.svg";
import {SwapMainAppContext} from '../../context/SwapMainAppContext';

import transImg from '../../static_files/dashboard.svg';
import transImgHover from '../../static_files/dashboardHover.svg';
import assetsImg from '../../static_files/robot.svg';
import assetsImgHover from '../../static_files/robotHover.svg';
import c2cImg from '../../static_files/models.svg';
import c2cImgHover from '../../static_files/modelsHover.svg';
import inviteImg from '../../static_files/dataset.svg';
import badge_explorer from '../../static_files/badge_explorer.png';
import badge_amplifier from '../../static_files/badge_amplifier.png'
import badge_innovator from '../../static_files/badge_innovator.png'
import bookImg from '../../static_files/bookIcon.svg';
import bookImgHover from '../../static_files/bookIconHover.svg';
import liveControlImg from '../../static_files/live control.svg';
import liveControlImgHover from '../../static_files/live controlHover.svg';

function SideMenu({isOpen, onOverlayClick, stopPropagation}) {
    const location = useLocation();
    const navigate = useNavigate();
    const [isRendered, setIsRendered] = useState(false);
    const [imagesLoaded, setImagesLoaded] = useState(false);
    const imagesRef = useRef({});
    const {
        userClass
    } = useContext(SwapMainAppContext);

    useEffect(() => {
        const preloadImages = () => {
            const images = [
                transImg, transImgHover, assetsImg, assetsImgHover, c2cImg, c2cImgHover, 
                liveControlImg, liveControlImgHover, bookImg, bookImgHover,
                badge_explorer, badge_innovator, badge_amplifier
            ];

            let loadedCount = 0;
            const totalImages = images.length;

            images.forEach(src => {
                if (imagesRef.current[src]) {
                    loadedCount++;
                    if (loadedCount === totalImages) {
                        setImagesLoaded(true);
                    }
                } else {
                    const img = new Image();
                    img.onload = () => {
                        loadedCount++;
                        imagesRef.current[src] = true;
                        if (loadedCount === totalImages) {
                            setImagesLoaded(true);
                        }
                    };
                    img.onerror = () => {
                        loadedCount++;
                        if (loadedCount === totalImages) {
                            setImagesLoaded(true);
                        }
                    };
                    img.src = src;
                }
            });
        };

        preloadImages();
    }, []);

    useEffect(() => {
        if (isOpen) {
            setIsRendered(true);
        }
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen && isRendered) {
            const timer = setTimeout(() => {
                setIsRendered(false);
            }, 500); //delay to make sure it compeltes

            return () => clearTimeout(timer);
        }
    }, [isOpen, isRendered]);

    const handleDashboardClick = () => {
        navigate('/');
        onOverlayClick();
    };
  const handleLiveControlClick = () => {
        navigate(`/live-control`);
        onOverlayClick();
    };
    const handleWhitepaperClick = () => {
        navigate('/whitepaper');
        onOverlayClick();
    };

    const handleFleetClick = () => {
        navigate('/fleet');
        onOverlayClick();
    };

    // const handleModelsClick = () => {
    //     // Models is coming soon - no navigation
    //     onOverlayClick();
    // };

    const handleDatasetClick = () => {
        // Dataset is coming soon - no navigation
        onOverlayClick();
    };


    const handleAccountClick = () => {
        navigate('/account');
        onOverlayClick();
    };

    if (!isOpen && !isRendered) {
        return null;
    }

    const menuContainerClass = `${styles.sideMenuContainer} ${isOpen ? styles.open : ''} ${imagesLoaded ? styles.imagesLoaded : ''}`;

    return (
        <>
            <div
                className={menuContainerClass}
                onClick={stopPropagation}
            >
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    height: '32px',
                    width: '100%',
                    marginBottom: '32px'
                }}>
                    <img
                        src={logo_svg}
                        style={{height: '34px', marginLeft: "8px", cursor: 'pointer'}}
                        alt="PrismaXAI"
                        onClick={() => window.open('https://prismax.ai/', '_blank')}
                    />
                    <button className={styles.closeButton} onClick={onOverlayClick}>
                        ✕
                    </button>
                </div>
                <div>
                    {/* Dashboard */}
                    <div
                        className={`${styles.menuItem} ${
                            location.pathname === '/' ? styles.selected : ''
                        } ${imagesLoaded ? styles.imageLoaded : ''}`}
                        onClick={handleDashboardClick}
                    >
                        <div className={styles.imageContainer}>
                            <img
                                src={location.pathname === '/' ? transImgHover : transImg}
                                alt="Dashboard"
                            />
                        </div>
                        <span>Dashboard</span>

                    </div>

                            {/* Live Control */}
                    {/*<div*/}
                    {/*    className={`${styles.menuItem} ${*/}
                    {/*        location.pathname === '/live-control' ? styles.selected : ''*/}
                    {/*    } ${imagesLoaded ? styles.imageLoaded : ''}`}*/}
                    {/*    onClick={handleLiveControlClick}*/}
                    {/*>*/}
                    {/*    <div className={styles.imageContainer}>*/}
                    {/*        <img*/}
                    {/*            src={liveControlImg}*/}
                    {/*            alt="live-control"*/}
                    {/*        />*/}
                    {/*    </div>*/}
                    {/*    <span>Live Control</span>*/}

                    {/*</div>*/}


                    {/* Robot Fleet */}
                    <div
                        className={`${styles.menuItem} ${
                            location.pathname === '/fleet' ? styles.selected : ''
                        } ${imagesLoaded ? styles.imageLoaded : ''}`}
                        onClick={handleFleetClick}
                    >
                        <div className={styles.imageContainer}>
                            <img
                                src={location.pathname === '/fleet' ? assetsImgHover : assetsImg}
                                alt="Robot Fleet"
                            />
                        </div>
                        <span>Robot Fleet</span>
                    </div>

                    {/* Models */}
                    <div
                        className={`${styles.menuItem} ${
                            location.pathname === '/Models' ? styles.selected : ''
                        } ${imagesLoaded ? styles.imageLoaded : ''}`}
                        // onClick={handleModelsClick}
                    >
                        <div className={styles.imageContainer}>
                            <img 
                                src={location.pathname === '/Models' ? c2cImgHover : c2cImg} 
                                alt="Models"
                            />
                        </div>
                        <span>Models</span>
                        <span style={{marginLeft: 'auto', fontSize: '12px', color: '#666'}}>(Coming Soon)</span>
                    </div>

                    {/* Dataset Library */}
                    <div
                        className={`${styles.menuItem} ${
                            location.pathname === '/dataset' ? styles.selected : ''
                        } ${imagesLoaded ? styles.imageLoaded : ''}`}
                        onClick={handleDatasetClick}
                    >
                        <div className={styles.imageContainer}>
                            <img
                                src={location.pathname === '/dataset' ? liveControlImgHover : liveControlImg}
                                alt="Live Control"
                            />
                        </div>
                        <span>Live Control</span>
                        <span style={{marginLeft: 'auto', fontSize: '12px', color: '#666'}}>(Coming Soon)</span>
                    </div>

                    {
                        <div className={styles.divider}></div>
                    }

                    {/* whitepaper */}
                    <div
                        className={`${styles.menuItem} ${styles.whitepaperItem} ${
                            location.pathname === '/whitepaper' ? styles.selected : ''
                        } ${imagesLoaded ? styles.imageLoaded : ''}`}
                        onClick={handleWhitepaperClick}
                    >
                        <div className={styles.imageContainer}>
                            <img
                                src={location.pathname === '/whitepaper' ? bookImgHover : bookImg}
                                alt="Whitepaper"
                            />
                        </div>
                        <span>Whitepaper</span>
                        {/*<span style={{marginLeft: 'auto', fontSize: '12px', color: '#666'}}>(Coming Soon)</span>*/}
                    </div>


                    {/* Account */}
                    <div
                        className={`${styles.menuItem} ${
                            location.pathname === '/account' ? styles.selected : ''
                        } ${imagesLoaded ? styles.imageLoaded : ''}`}
                        onClick={handleAccountClick}
                        style={{
                            marginTop: '30px'
                        }}
                    >
                        <div className={styles.imageContainer}>
                            <img
                                className={styles.account_logo}
                                src={userClass === 'Amplifier Member' ?
                                    badge_amplifier : (userClass === 'Innovator Member' ? badge_innovator : badge_explorer)}
                                alt="account icon"
                            />
                        </div>
                        <span>Account</span>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SideMenu;